module.exports = __webpack_public_path__ + "static/5-053fbfa35cd6d71b6f0ae93faf025f4f.jpg";